import React, { useState } from 'react';
import { TailwindPlusLayout } from './TailwindPlusLayout';
import { AppMode, LeadPageType, ClientPageType } from '@/shared/types/appTypes';
// ChatTabType now defined locally since ChatBottomControls was removed
type ChatTabType = 'conversation' | 'templates' | 'automation' | 'bot' | 'responses';
import { FocusViewMode } from '@/modules/leads/components/LeadListBottomControls';
import { LeadTabType } from '@/modules/leads/components/LeadBottomControls';
import './BaseLayout.css';

interface BaseLayoutProps {
  children: React.ReactNode;
  currentPage: LeadPageType | ClientPageType;
  mode: AppMode;
  onModeChange: (mode: AppMode) => void;
  leadCount?: number;
  clientCount?: number;
  // Props para los submenus del sidebar
  activeChatTab?: ChatTabType;
  onChatTabChange?: (tab: ChatTabType) => void;
  activeFocusMode?: FocusViewMode;
  onFocusModeChange?: (mode: FocusViewMode) => void;
  activeLeadTab?: LeadTabType;
  onLeadTabChange?: (tab: LeadTabType) => void;
  currentLead?: {
    name: string;
    value: number;
  } | null;
}

let baseLayoutRenderCount = 0;

export const BaseLayout: React.FC<BaseLayoutProps> = ({
  children,
  currentPage,
  mode,
  onModeChange,
  leadCount = 0,
  clientCount = 0,
  activeChatTab,
  onChatTabChange,
  activeFocusMode,
  onFocusModeChange,
  activeLeadTab,
  onLeadTabChange,
  currentLead
}) => {
  baseLayoutRenderCount++;
  const leadsNavigationItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '🏠' },
    { id: 'focus-leads', label: 'Leads', icon: '👥' },
    { id: 'chat', label: 'Chat', icon: '💬' },
  ];

  const clientsNavigationItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '🏠' },
    { id: 'projects', label: 'Proyectos', icon: '🏗️' },
    { id: 'billing', label: 'Facturación', icon: '💰' },
    { id: 'deliveries', label: 'Entregas', icon: '📋' },
    { id: 'support', label: 'Soporte', icon: '📞' },
  ];

  const navigationItems = mode === 'leads' ? leadsNavigationItems : clientsNavigationItems;

  return (
    <TailwindPlusLayout
      mode={mode}
      onModeChange={onModeChange}
      currentPage={currentPage}
      leadCount={leadCount}
      clientCount={clientCount}
    >
      {children}
    </TailwindPlusLayout>
  );
};